// src/components/Accordion.js
import React, { useState } from 'react';

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`accordion-item ${isOpen ? 'active' : ''}`}>
      <div className="accordion-header" onClick={toggleAccordion}>
        <h3 className="accordion-title">{title}</h3>
        <span className="toggle-icon" aria-hidden="true">›</span>
      </div>

      <div className="accordion-content">
        <p>{content}</p>
      </div>
    </div>
  );
};

const Accordion = () => {
  const items = [
    {
      title: 'С чего начать?',
      content:
        'Пришлите ссылку, скриншот или описание товара. Мы проверим наличие, цену и возможность выкупа.',
    },
    {
      title: 'Как заказать?',
      content:
        'Укажите ссылку, размер, цвет и цену. Если есть промокод или дополнительная скидка — добавьте это в сообщение.',
    },
    {
      title: 'Оформление заказа и оплата',
      content:
        'После расчета менеджер подтверждает итоговую сумму и способ оплаты. Оплатить можно через кнопку на сайте или по реквизитам.',
    },
    {
      title: 'Подтверждение оплаты',
      content:
        'После оплаты отправьте подтверждение через кнопку «Сообщить об оплате» или в личные сообщения.',
    },
    {
      title: 'Выкуп заказа',
      content:
        'После поступления оплаты мы выкупаем товар и фиксируем заказ в системе.',
    },
    {
      title: 'Какие сроки доставки?',
      content:
        'Ориентировочный срок доставки — 4–8 недель. Возможны задержки, которые не зависят от сервиса.',
    },
    {
      title: 'Оплата доставки',
      content:
        'Доставка рассчитывается отдельно после поступления товара на склад и взвешивания.',
    },
    {
      title: 'Как узнать статус заказа?',
      content:
        'Статусы доступны в личном кабинете/боте. При важных изменениях отправляем уведомление.',
    },
    {
      title: 'Где забрать заказ?',
      content:
        'Выдача возможна через согласованный пункт выдачи или доставку по договоренности.',
    },
    {
      title: 'Если товар не подошел?',
      content:
        'Возврат невозможен. Мы оказываем услугу выкупа и доставки; размер, цвет, фасон и характеристики товара клиент выбирает самостоятельно.',
    },
  ];

  return (
    <section className="container faq-modern-section">
      <div className="faq-modern">
        <div className="faq-modern-head">
          <p className="faq-modern-kicker">FAQ</p>
          <h2>Условия и правила оформления заказа</h2>
        </div>

        <div className="accordion">
          {items.map((item, index) => (
            <AccordionItem
              key={index}
              title={item.title}
              content={item.content}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accordion;
